import { log, FACILITY as LOG_FACILITY } from './log';
import { getPartModelData, ModelStateElement, } from '../analytics-engine';
import { FrameCacheMode } from '../types';
import { AnalyticsTuple } from '../analytics-lib/analytics-tuple';
var LOG = LOG_FACILITY.FRAME_CACHE;
var SessionSimulator = (function () {
    function SessionSimulator(dataset) {
        this.dataset = dataset;
        this.timingsIndex = 0;
        this.lastIndex = this.dataset.timings.length;
        if (dataset.window && dataset.window.firstFrame) {
            this.timingsIndex = dataset.window.firstFrame;
        }
        if (dataset.window &&
            dataset.window.lastFrame &&
            dataset.window.lastFrame < this.lastIndex) {
            this.lastIndex = dataset.window.lastFrame;
        }
    }
    SessionSimulator.prototype.nextFrame = function () {
        var _this = this;
        if (this.timingsIndex < this.lastIndex) {
            var getSamples = function (element, timestamp) {
                return Array.from(Array(10).keys()).map(function (partIndex) {
                    return getPartModelData(_this.dataset.modelStates[timestamp], partIndex, element);
                });
            };
            var timestamp = this.dataset.timings[this.timingsIndex++];
            return {
                timestamp: timestamp,
                readings: getSamples(ModelStateElement.QSENSOR, timestamp),
                accelerations: getSamples(ModelStateElement.ACCEL, timestamp),
                angularVelocities: getSamples(ModelStateElement.ANG_VEL, timestamp),
            };
        }
        return undefined;
    };
    return SessionSimulator;
}());
function reloadDataSet(obj, engine) {
    var sim = new SessionSimulator(obj);
    engine.initialize();
    engine.frameCache.setMode(FrameCacheMode.Live);
    engine.body.setAlignment(obj.alignment.qInitials, obj.alignment.axisTransforms);
    engine.body.alignment.config.frames = obj.alignment.frames;
    var sources = obj.source.split(/:|-/);
    if (sources.length === 4) {
        engine.obcTopId = sources[0];
        engine.harnessTopId = sources[1];
        engine.obcBottomId = sources[2];
        engine.harnessBottomId = sources[3];
    }
    else {
        log.error(LOG, "Error splitting dataset source field during reload " + obj.source);
    }
    engine.frameCache.setMode(FrameCacheMode.Capture);
    var frame = null;
    while ((frame = sim.nextFrame())) {
        engine.pushQuaternions(frame);
    }
    engine.frameCache.setMode(FrameCacheMode.Playback);
    return true;
}
export function dataSetLoader3(obj, engine) {
    if (!obj ||
        !(obj.version === '3.4' ||
            obj.version === '3.3' ||
            obj.version === '3.2' ||
            obj.version === '3.1' ||
            obj.version === '3.0')) {
        log.error(LOG, 'load called with invalid dataset');
        return false;
    }
    if (obj.version !== '3.3' && obj.version !== '3.4') {
        log.info(LOG, 'generating analytics');
        obj.reload = true;
    }
    engine.setMobileAppId(obj.mobileAppId);
    engine.setMovementName(obj.movementName || obj.movementTitle);
    engine.body.setAlignment(obj.alignment.qInitials, obj.alignment.axisTransforms);
    if (obj.reload) {
        log.info(LOG, 'reloading dataset using sensor data');
        reloadDataSet(obj, engine);
    }
    else {
        obj.timings.forEach(function (time) {
            engine.frameCache.timingsSet.add(time);
            engine.frameCache.analyticTuples.set(time, new AnalyticsTuple(time, obj.analyticTuples[time]));
            engine.frameCache.modelStates.set(time, obj.modelStates[time]);
        });
    }
    engine.frameCache.timelineTags = obj.timelineTags;
    engine.frameCache.startTime = obj.startTime;
    engine.frameCache.endTime = obj.endTime;
    engine.frameCache.duration = obj.duration;
    engine.frameCache.frameCount = engine.frameCache.timingsSet.size;
    return true;
}
//# sourceMappingURL=dataset-loader-3.js.map